import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LoginService } from 'app/login.service';
import { MarketData } from 'app/models/MarketData';
import { Utilisateur } from 'app/models/Utilisateur';
import { DataService } from 'app/shared/data.service';
import { UtilisateurService } from 'app/shared/utilisateur.service';
import { environment } from 'environments/environment';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-popup-watchlist',
    templateUrl: './popup-watchlist.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatOptionModule,
        MatIconModule,
        MatInputModule,
        MatTooltipModule,
        MatProgressBarModule,
        MatButtonModule,
        RouterModule,
        MatPaginatorModule,
        MatTableModule,
    ],
})
export class PopupWatchlistComponent implements OnInit {
    watchlist: string[] = [];
    recentTransactionsTableMatSort: MatSort;
    displayedColumns: string[] = ['Nom Actif', 'action'];
    dataSource = new MatTableDataSource<MarketData>();
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    serveur_name = environment.serveur_name;
    host_name = environment.host_name;
    idUtilisateurConnecte: string = '';
    dataUtilisateurConnecte: Utilisateur;
    existe: boolean = false;

    constructor(
        private loginService: LoginService,
        private dataService: DataService,
        private utilisateurService: UtilisateurService,
        public dialog: MatDialog
    ) {}

    @ViewChild('TABLE', { read: ElementRef }) table: ElementRef;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild('filter', { static: true }) filter: ElementRef;

    ngOnInit(): void {
        this.utilisateurService
            .getUtilisateurByUsername(this.loginService.getUsername())
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (dataUtilisateur: Utilisateur[]) => {
                    this.dataUtilisateurConnecte = dataUtilisateur[0];
                    this.idUtilisateurConnecte =
                        this.dataUtilisateurConnecte.userId;
                    this.watchlist =
                        this.dataUtilisateurConnecte.watchlist || [];
                },
            });
        this.dataService.recupererTout().subscribe((data: MarketData[]) => {
            this.dataSource.data = data;
        });
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
    appliquerFiltre(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        for (let i = 0; i < this.dataSource.data.length; i++)
            this.dataSource.data[i]['name'] =
                this.dataSource.data[i].referentiel.stockName;

        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    supprimerTitre(titre: string) {
        this.watchlist.splice(this.watchlist.indexOf(titre), 1);
        this.dataUtilisateurConnecte.watchlist = this.watchlist;
        this.utilisateurService
            .mettreAJourUtilisateur(
                this.idUtilisateurConnecte,
                this.dataUtilisateurConnecte
            )
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe();
    }

    ajouterTitre(titre: string) {
        this.watchlist.push(titre);
        this.dataUtilisateurConnecte.watchlist = this.watchlist;
        this.utilisateurService
            .mettreAJourUtilisateur(
                this.idUtilisateurConnecte,
                this.dataUtilisateurConnecte
            )
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe();
    }

    sauvegarder() {
        this.dialog.closeAll();
    }

    showDeleteButton(stockName: string) {
        return this.watchlist.includes(stockName);
    }
}
